import React from 'react';

export type AccountType = "Member" | "Guest";

export interface IAuthContext {
    isAuthenticated: boolean;
    env?: string;
    name?: string;
    email?: string;
    clientIds?: number[];
    blobBaseURL?: string;
    site?: string;
    tid?: string;
    roles: string[];
    isPHAEditor?: boolean;
    isInternalUser?: boolean;
    isExternalUser?: boolean;
    isAdmin?: boolean;
    isSubAdmin?: boolean;
    azureMaps?: { clientId: string };
    fullCalendar?: { licenseKey: string };
}

const defaultContext: IAuthContext = {
    isAuthenticated: false,
    roles: ['Reader']
}

export const AuthContext = React.createContext<IAuthContext>(defaultContext);
export const AuthConsumer = AuthContext.Consumer;